import HTTP_METHODS from "src/general/constants/http/httpMethods";
import {
	UserPutRequest as Req,
	UserPutResponse as Res,
} from "src/business.InterfaceLayer/store/entities/user.entity/redux/api/types/PUT";
import { createBaseQueryDefinition } from "src/business.InterfaceLayer/store/services/utils.service/ResponseTransforms";
import MAIN_PATHS from "src/business.InterfaceLayer/store/mainPaths";
import { ApiQueryBuilder } from "src/business.InterfaceLayer/store/types/ApiQueryBuilder.type";
import { AuthFromDtoPut as Dto } from "src/business.InterfaceLayer/store/entities/user.entity/services/dto/from.dto";
import { Nullable } from "../../../../../types/Nullable.type";
import USER_PATHS from "../../paths";
import { USER_FIELDS } from "../../fields";
import { userApi } from "../index";
import COMMON_FIELDS from "../../../../../../../general/constants/commonFields";
import HTTP_STATUSES from "../../../../../../../general/constants/http/httpStatuses";
import { IUsersFilter, STATUS_USER } from "../../type";
import { usersFilterSlice } from "../../slice";

const putRequestBaseDefinition = createBaseQueryDefinition(
	HTTP_METHODS.PUT,
	MAIN_PATHS.AUTHORIZATION
);

const postRequestBaseDefinitionCore = createBaseQueryDefinition(
	HTTP_METHODS.PUT,
	MAIN_PATHS.CORE
);

const userApiPutQueries = (build: ApiQueryBuilder) => ({
	putUserChangeCoordination: build.mutation<
		Nullable<Res.UserChangeCoordination>,
		Req.UserChangeCoordination
	>({
		query: (body) => ({
			...postRequestBaseDefinitionCore({
				path: `${USER_PATHS.USER_CHANGE_COORDINATION}`,
			}),
			body,
		}),
		transformResponse: Dto.userChangeCoordinationFromDto,
		// TODO: это пример как юзать стор, этот код не  используется
		async onQueryStarted(body, { dispatch, queryFulfilled, getState }) {
			try {
				const { data: updatedPost } = await queryFulfilled;

				const state = getState();
				const filters = state?.[usersFilterSlice.name] as IUsersFilter;

				dispatch(
					userApi.util.updateQueryData("getUsers", filters, (draft: any) => {
						if (updatedPost?.[COMMON_FIELDS.STATUS] === HTTP_STATUSES.SUCCESS) {
							const newUsers = draft?.[COMMON_FIELDS.DATA]?.[
								COMMON_FIELDS.DATA
							].map((e: any) => {
								const newE = { ...e };
								if (
									body?.[USER_FIELDS.USER_IDS].includes(e?.[USER_FIELDS.ID])
								) {
									newE[USER_FIELDS.STATUS] = body?.[USER_FIELDS.RESULT]
										? STATUS_USER.ACTIVE
										: STATUS_USER.BLOCKED;
								}

								return newE;
							});
							draft[COMMON_FIELDS.DATA][COMMON_FIELDS.DATA] = newUsers;
							draft[COMMON_FIELDS.DATA][COMMON_FIELDS.DTO] = newUsers;
							return draft;
						}
					})
				);
			} catch {}
		},
		invalidatesTags: [`${MAIN_PATHS.USER}TAG_COUNT`, `${MAIN_PATHS.USER}TAG`],
	}),
	putUserRecoveryPassword: build.mutation<
		Nullable<Res.UserRecoveryPassword>,
		Req.UserRecoveryPassword
	>({
		query: (body) => ({
			...putRequestBaseDefinition({
				path: `${USER_PATHS.USERS}/curuser/resetpwd`,
			}),
			body,
		}),
		transformResponse: Dto.userRecoveryPasswordFromDto,
	}),
	putUserEdit: build.mutation<Nullable<Res.UserEdit>, Req.UserEdit>({
		query: (body) => ({
			...postRequestBaseDefinitionCore({
				path: `${USER_PATHS.USER_EDIT}/${body[USER_FIELDS.ID]}`,
			}),
			body,
		}),
		transformResponse: Dto.userEditFromDto,
		invalidatesTags: [`${MAIN_PATHS.USER}TAG_COUNT`, `${MAIN_PATHS.USER}TAG`],
	}),
	putUserChangePasswordRequest: build.mutation<
		Nullable<Res.UserChangePasswordRequest>,
		Req.UserChangePasswordRequest
	>({
		query: (body) => ({
			...putRequestBaseDefinition({
				path: `${USER_PATHS.USER_CHANGE_PASSWORD_REQUEST}`,
			}),
			body,
		}),
		transformResponse: Dto.userChangePasswordRequestFromDto,
		invalidatesTags: [`${MAIN_PATHS.USER}TAG_COUNT_REQUESTS_PASSWORD`],
	}),

	putUserChangeAvatar: build.mutation<
		Nullable<Res.UserChangeAvatarRequest>,
		Req.UserChangeAvatarRequest
	>({
		query: (body) => ({
			...postRequestBaseDefinitionCore({
				path: `${USER_PATHS.USER_CHANGE_AVATAR}/${
					body[USER_FIELDS.UID]
				}/avatar`,
			}),
			body: (() => {
				const formData = new FormData();

				formData.append(USER_FIELDS.UID, String(body[USER_FIELDS.UID]));
				formData.append(USER_FIELDS.AVATAR_FILE, body[USER_FIELDS.AVATAR_FILE]);

				return formData;
			})(),
		}),
		transformResponse: Dto.userChangePasswordRequestFromDto,
		invalidatesTags: [
			`${MAIN_PATHS.USER}TAG_COUNT_REQUESTS_PASSWORD`,
			`${MAIN_PATHS.USER}TAG_PROFILE`,
		],
	}),
});

export default userApiPutQueries;
